/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuFilterColor_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterColor_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuColorSelect_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
